import "../styles/MainCeprPage.css";
import "../../../../common/UI/BackButton/styles/BackButton.css";

import { Link } from "react-router-dom";
import {
  $backButton,
  setGuideMode,
  setOpenModel,
  setOpenVideo,
} from "../../../../common/UI/GuideButtons/logic/GuideLogic";
import { useEffect, useState } from "react";
import { useStore } from "effector-react";
import { titleName } from "../../../../common/function";
import { SwitcherButtom } from "../../../../common/UI/SwitcherButton/organoids/switcherbuttom";
import { useTranslation } from "react-i18next";
import { LangButton } from "../../../../common/UI/LangButton/organoids/LangButton";

import SOZH from "../../../../common/assets/images/Cepr/MainPage/SOZH.jpg";
import RECTANGLE from "../../../../common/assets/images/Cepr/MainPage/Play.png";
import FSI from "../../../../common/assets/images/Cepr/MainPage/ФСИ.svg";
import { Tooltip } from "@mui/material";

export interface IForMainModal {
  image: string;
  haveBanner: boolean;
  title: string;
  text: string;
  href: string;
}

export const MainPagePwa = () => {
  const BackButton = useStore($backButton);
  const [, setSwitcher] = useState<boolean>(false);

  useEffect(() => {
    setGuideMode(false);
    setTimeout(() => {
      setSwitcher(true);
    }, 5000);
  }, []);

  const { t } = useTranslation();
  titleName(t("BrowserLine.MainPage"));

  return (
    <>
      <div className="mainFlexCepr">
        <div className="mainFlexCeprLogo">
          <img src={t("MainPage.Picture")!} alt="" className="logoCepr" />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <div className="imageCepr">
            <img src={SOZH} alt="" className="imageCeprBlock" />
            <Link to="/pwa/photo">
              <Tooltip
                id="button-tooltip"
                title={t("MainPage.SelectPage")}
                children={
                  <img
                    src={RECTANGLE}
                    className="buttonCeprNextRun"
                    alt=""
                    onClick={() => {
                      setGuideMode(false);
                      setOpenVideo(true);
                      setOpenModel(true);
                    }}
                  />
                }
              />
            </Link>
          </div>
        </div>
      </div>
      <div className="MainPagePwa_BlockRight_Absolute">
        <LangButton />
        <SwitcherButtom linkName={"/pwa/photo"} />
      </div>

      <div className="main_BackButton-block">
        <Link to="/">
          <div className={BackButton ? "BackButton_To_GeneralPage" : ""}></div>
        </Link>
        <img src={FSI} alt="FSI" className="main_BackButton-block__FSI" />
      </div>
    </>
  );
};
